(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function syncFooterDisclosures() {
      var isDesktop = window.matchMedia('(min-width: 600px)').matches;
      document.querySelectorAll('[data-sl-footer-disclosure]').forEach(function (el) {
        el.open = isDesktop;
      });
    }
    syncFooterDisclosures();
    window.addEventListener('resize', syncFooterDisclosures);
    document.addEventListener('shopify:section:load', syncFooterDisclosures);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    // Mobile predictive-search drawer enhancements (2026-09-22). Only touches the mobile
    // (max-width:749px) SL-styled search modal — desktop keeps Dawn's own text untouched.
    // Two things CSS/Liquid alone can't do: (1) Shopify's predictive search "suggestions" are
    // live query/collection matches generated by Shopify itself, not static theme content, so
    // there's no theme setting to rename them — this remaps only the exact labels asked for,
    // by their rendered text, matched case-sensitively against the live text each time results
    // render; anything outside this list (a different search term, a renamed/removed collection)
    // is left exactly as Shopify returns it. The durable fix, if these should always read this
    // way, is renaming the underlying collections/search terms in Shopify Admin. (2) the CTA
    // button's label comes from a sitewide locale string reused by the desktop dropdown and the
    // search-results page too, so it's rewritten here rather than in the locale file to avoid
    // changing text on those other surfaces that weren't part of this request.
    var SL_MOBILE_MAX_WIDTH = 749;
    var SUGGESTION_LABEL_MAP = {
      'Birthday Gifts': 'Birthday gifts',
      'Birthday All': 'All birthday cards',
      'Jellycat Birthday': 'Jellycat birthday gifts',
      'Animal Birthday': 'Animal birthday cards',
      'Pop Culture Birthday': 'Pop culture birthday cards',
    };
    var MOBILE_PLACEHOLDER = 'Search cards and gifts...';

    function isMobileViewport() {
      return window.matchMedia('(max-width: ' + SL_MOBILE_MAX_WIDTH + 'px)').matches;
    }

    function enhanceMobileSearchInput(input) {
      if (!input || !isMobileViewport()) return;
      if (!input.dataset.slOriginalPlaceholder) {
        input.dataset.slOriginalPlaceholder = input.getAttribute('placeholder') || '';
      }
      input.setAttribute('placeholder', MOBILE_PLACEHOLDER);
    }

    function relabelSuggestion(headingEl) {
      var exact = SUGGESTION_LABEL_MAP[headingEl.textContent.trim()];
      // Only write when the text actually needs to change: this runs inside a MutationObserver
      // callback (see watchMobileSearchModal below), and an unconditional `.textContent =` is
      // itself a childList mutation that would re-trigger that same observer every time, even
      // once the value already matches. Without this guard that becomes an infinite
      // mutate/observe loop that pegs the main thread and freezes the page (found 2026-09-22).
      if (exact && headingEl.textContent.trim() !== exact) headingEl.textContent = exact;
    }

    function enhanceMobileSearchResults(resultsRoot, input) {
      if (!resultsRoot || !isMobileViewport()) return;

      resultsRoot.querySelectorAll('.predictive-search__item-query-result, #predictive-search-results-queries-list .predictive-search__item-heading').forEach(relabelSuggestion);

      var ctaText = resultsRoot.querySelector('[data-predictive-search-search-for-text]');
      // Read the term straight from the input's own value rather than parsing it back out of
      // Shopify's rendered CTA text: that text uses locale-specific quote glyphs (smart quotes
      // by default, not straight ASCII ones), so a regex looking for one exact quote character
      // silently stops matching the moment the locale string's quoting changes and leaves the
      // CTA unrewritten (found 2026-09-22, after the ASCII-quote regex matched nothing).
      var term = input ? input.value.trim() : '';
      if (ctaText && term) {
        var newText = 'Search for "' + term + '"';
        // Only write if the text would actually change: this runs inside a MutationObserver
        // callback (see watchMobileSearchModal below), and an unconditional `.textContent =`
        // is itself a childList mutation that would re-trigger that same observer every time,
        // even once the value already matches. Without this guard that becomes an infinite
        // mutate/observe loop that pegs the main thread and freezes the page (found 2026-09-22).
        if (newText !== ctaText.textContent) ctaText.textContent = newText;
      }
    }

function watchMobileSearchModal(headerWrapper) {
      var resultsRoot = headerWrapper.querySelector('[data-predictive-search]');
      var input = headerWrapper.querySelector('.search-modal__form .search__input');
      if (!resultsRoot || !input) return;

      enhanceMobileSearchInput(input);
      enhanceMobileSearchResults(resultsRoot, input);

      // Disconnect while we mutate the DOM ourselves and reconnect right after: belt-and-braces
      // alongside the idempotency checks in enhanceMobileSearchResults/relabelSuggestion above,
      // so our own writes can never be observed as a trigger for another round even if a future
      // edit here reintroduces an unconditional write.
      var observer = new MutationObserver(function () {
        observer.disconnect();
        enhanceMobileSearchResults(resultsRoot, input);
        observer.observe(resultsRoot, { childList: true, subtree: true });
      });
      observer.observe(resultsRoot, { childList: true, subtree: true });

      window.addEventListener('resize', function () {
        enhanceMobileSearchInput(input);
        enhanceMobileSearchResults(resultsRoot, input);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.header-wrapper.sl-active').forEach(watchMobileSearchModal);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function enhanceSortSelect(select) {
      if (!select || select.dataset.slSortEnhanced === 'true') return;
      var wrap = select.closest('.select');
      if (!wrap) return;

      var options = Array.prototype.slice.call(select.options);
      if (options.length < 2) return;

      var isMobile = !!select.closest('.mobile-facets__sort');

      var details = document.createElement('details');
      details.className = isMobile
        ? 'sl-mobile-sort-disclosure'
        : 'disclosure-has-popup facets__disclosure sl-sort-disclosure';

      var summary = document.createElement('summary');
      summary.className = isMobile ? 'sl-mobile-sort-summary' : 'facets__summary caption-large focus-offset';
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-haspopup', 'listbox');
      summary.setAttribute('aria-expanded', 'false');
      if (isMobile) {
        // Dawn's MenuDrawer.bindEvents() runs again after every AJAX update and would bind its drill-in
        // handlers to this summary and the option buttons. Ours are attached first, so stop the click here.
        summary.addEventListener('click', function (event) {
          event.stopImmediatePropagation();
        });
      }

      var summaryInner = document.createElement('div');
      var summaryLabel = document.createElement('span');
      summaryLabel.className = 'facets__summary-label';

      var selected = options.filter(function (o) {
        return o.value === select.value;
      })[0] || options[0];
      summaryLabel.textContent = selected.textContent.trim();
      summaryInner.appendChild(summaryLabel);
      if (isMobile) {
        // Bring the "Sort by:" words into the summary so the whole row is the toggle; the native label
        // stays in the DOM, visually hidden, for the hidden select.
        var sortLabel = wrap.parentNode.querySelector('label');
        if (sortLabel) {
          var lead = document.createElement('span');
          lead.className = 'sl-mobile-sort-lead';
          lead.textContent = sortLabel.textContent.trim();
          summaryInner.insertBefore(lead, summaryLabel);
          sortLabel.classList.add('sl-sort-label-hidden');
        }
        var sortRow = wrap.closest('.mobile-facets__summary');
        if (sortRow) sortRow.classList.add('sl-mobile-sort-row');
      }

      var existingCaret = wrap.querySelector('.icon-caret');
      if (existingCaret) summaryInner.appendChild(existingCaret.cloneNode(true));
      summary.appendChild(summaryInner);
      details.appendChild(summary);

      var panel = document.createElement('div');
      panel.className = isMobile ? 'sl-mobile-sort-display' : 'facets__display sl-sort-display';
      var list = document.createElement('ul');
      list.className = 'facets-layout facets-layout-list facets-layout-list--text facets__list list-unstyled';
      list.setAttribute('role', 'listbox');

      options.forEach(function (option) {
        var li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sl-sort-option';
        btn.setAttribute('role', 'option');
        var isActive = option.value === select.value;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) btn.classList.add('sl-sort-option--active');
        btn.textContent = option.textContent.trim();
        btn.addEventListener('click', function (event) {
          if (isMobile) event.stopImmediatePropagation();
          if (select.value !== option.value) {
            select.value = option.value;
            // facets.js does not re-render this block after a sort change, so refresh it here.
            summaryLabel.textContent = option.textContent.trim();
            Array.prototype.forEach.call(list.querySelectorAll('.sl-sort-option'), function (other) {
              var on = other === btn;
              other.classList.toggle('sl-sort-option--active', on);
              other.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          details.removeAttribute('open');
          summary.focus();
        });
        li.appendChild(btn);
        list.appendChild(li);
      });

      panel.appendChild(list);
      details.appendChild(panel);
      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open && isMobile) {
          details.scrollIntoView({
            block: 'nearest',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      });

      wrap.classList.add('sl-sort-select-hidden');
      wrap.parentNode.insertBefore(details, wrap.nextSibling);
      select.dataset.slSortEnhanced = 'true';
    }

    function enhanceAllSortSelects(root) {
      (root || document)
        .querySelectorAll('.sl-active select.facet-filters__sort, .sl-active .mobile-facets__sort select')
        .forEach(enhanceSortSelect);
    }

    function watchSortingContainers() {
      document.querySelectorAll('.sl-active .facet-filters.sorting').forEach(function (sortingEl) {
        if (sortingEl.dataset.slSortWatched === 'true') return;
        sortingEl.dataset.slSortWatched = 'true';
        var observer = new MutationObserver(function () {
          enhanceAllSortSelects(sortingEl);
        });
        observer.observe(sortingEl, { childList: true, subtree: true });
      });
    }

    function watchMobileSortContainers() {
      document.querySelectorAll('.sl-active .mobile-facets__main').forEach(function (containerEl) {
        if (containerEl.dataset.slMobileSortWatched === 'true') return;
        containerEl.dataset.slMobileSortWatched = 'true';
        var observer = new MutationObserver(function () {
          enhanceAllSortSelects(containerEl);
        });
        observer.observe(containerEl, { childList: true, subtree: true });
      });
    }

    document.addEventListener('click', function (event) {
      document
        .querySelectorAll('.sl-active .facets__disclosure[open], .sl-active .sl-mobile-sort-disclosure[open]')
        .forEach(function (details) {
          if (!details.contains(event.target)) {
            details.removeAttribute('open');
          }
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
      enhanceAllSortSelects(document);
      watchSortingContainers();
      watchMobileSortContainers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    function findNavigation(productInfo) {
      const items = Array.from(
        productInfo.querySelectorAll('.slim-page-navigation-item')
      );

      if (!items.length) return null;

      const parent = items[0].parentElement;

      if (!parent) return null;

      const itemsInsideParent = parent.querySelectorAll(
        '.slim-page-navigation-item'
      );

      if (itemsInsideParent.length !== items.length) return null;

      return parent;
    }

    function movePrintessNavigation(productInfo) {
      const navigation = findNavigation(productInfo);

      const mediaWrapper = productInfo.querySelector(
        '.product__media-wrapper'
      );

      if (!navigation || !mediaWrapper) return;

      const stickyMediaGallery =
        mediaWrapper.querySelector(
          'media-gallery.product__column-sticky'
        ) ||
        mediaWrapper.querySelector('media-gallery') ||
        mediaWrapper;

      navigation.classList.add('sl-bottom-page-navigation');

      let heading = productInfo.querySelector(
        '.sl-page-navigation-heading'
      );

      if (!heading) {
        heading = document.createElement('p');
        heading.className = 'sl-page-navigation-heading';
        heading.textContent = 'View card';
      }

      if (!heading.id) {
        heading.id = `sl-page-navigation-heading-${
          productInfo.dataset.section || 'product'
        }`;
      }

      navigation.setAttribute('aria-labelledby', heading.id);

      if (
        navigation !== stickyMediaGallery &&
        !navigation.contains(stickyMediaGallery) &&
        (
          navigation.parentElement !== stickyMediaGallery ||
          stickyMediaGallery.lastElementChild !== navigation
        )
      ) {
        stickyMediaGallery.appendChild(navigation);
      }

      if (navigation.previousElementSibling !== heading) {
        stickyMediaGallery.insertBefore(heading, navigation);
      }
    }

    function initialiseProductInfo(productInfo) {
      let updateScheduled = false;

      function scheduleUpdate() {
        if (updateScheduled) return;

        updateScheduled = true;

        requestAnimationFrame(() => {
          updateScheduled = false;
          movePrintessNavigation(productInfo);
        });
      }

      const observer = new MutationObserver(scheduleUpdate);

      observer.observe(productInfo, {
        childList: true,
        subtree: true
      });

      scheduleUpdate();
    }

    function initialise() {
      document
        .querySelectorAll('product-info.sl-active')
        .forEach(initialiseProductInfo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise);
    } else {
      initialise();
    }
  })();

  (() => {
    // Pairs with the [data-printess-loading] CSS above. Runs for every Printess product,
    // not just .sl-active ones, since the flash it prevents isn't an SL-styling concern.
    function initialisePrintessFallback(productInfo) {
      const variantSelects = productInfo.querySelector('variant-selects');

      if (!variantSelects) return;

      let settled = false;

      function reveal() {
        if (settled) return;

        settled = true;
        productInfo.removeAttribute('data-printess-loading');
        observer.disconnect();
        clearTimeout(timeoutId);
      }

      const observer = new MutationObserver(() => {
        if (variantSelects.classList.contains('printess-hidden')) {
          reveal();
        }
      });

      observer.observe(variantSelects, {
        attributes: true,
        attributeFilter: ['class']
      });

      // Safety net: if Printess hasn't taken over within 5s (slow load, network issue, or
      // Printess itself being down), stop waiting so the native picker stays usable instead
      // of remaining invisible with no fallback.
      const timeoutId = setTimeout(reveal, 5000);
    }

    function initialisePrintessFallbacks() {
      document
        .querySelectorAll('product-info[data-printess-loading]')
        .forEach(initialisePrintessFallback);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialisePrintessFallbacks);
    } else {
      initialisePrintessFallbacks();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    function enhanceSortSelect(select) {
      if (!select || select.dataset.slSortEnhanced === 'true') return;
      var wrap = select.closest('.select');
      if (!wrap) return;

      var options = Array.prototype.slice.call(select.options);
      if (options.length < 2) return;

      var isMobile = !!select.closest('.mobile-facets__sort');

      var details = document.createElement('details');
      details.className = isMobile
        ? 'sl-mobile-sort-disclosure'
        : 'disclosure-has-popup facets__disclosure sl-sort-disclosure';

      var summary = document.createElement('summary');
      summary.className = isMobile ? 'sl-mobile-sort-summary' : 'facets__summary caption-large focus-offset';
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-haspopup', 'listbox');
      summary.setAttribute('aria-expanded', 'false');
      if (isMobile) {
        // Dawn's MenuDrawer.bindEvents() runs again after every AJAX update and would bind its drill-in
        // handlers to this summary and the option buttons. Ours are attached first, so stop the click here.
        summary.addEventListener('click', function (event) {
          event.stopImmediatePropagation();
        });
      }

      var summaryInner = document.createElement('div');
      var summaryLabel = document.createElement('span');
      summaryLabel.className = 'facets__summary-label';

      var selected = options.filter(function (o) {
        return o.value === select.value;
      })[0] || options[0];
      summaryLabel.textContent = selected.textContent.trim();
      summaryInner.appendChild(summaryLabel);
      if (isMobile) {
        // Bring the "Sort by:" words into the summary so the whole row is the toggle; the native label
        // stays in the DOM, visually hidden, for the hidden select.
        var sortLabel = wrap.parentNode.querySelector('label');
        if (sortLabel) {
          var lead = document.createElement('span');
          lead.className = 'sl-mobile-sort-lead';
          lead.textContent = sortLabel.textContent.trim();
          summaryInner.insertBefore(lead, summaryLabel);
          sortLabel.classList.add('sl-sort-label-hidden');
        }
        var sortRow = wrap.closest('.mobile-facets__summary');
        if (sortRow) sortRow.classList.add('sl-mobile-sort-row');
      }

      var existingCaret = wrap.querySelector('.icon-caret');
      if (existingCaret) summaryInner.appendChild(existingCaret.cloneNode(true));
      summary.appendChild(summaryInner);
      details.appendChild(summary);

      var panel = document.createElement('div');
      panel.className = isMobile ? 'sl-mobile-sort-display' : 'facets__display sl-sort-display';
      var list = document.createElement('ul');
      list.className = 'facets-layout facets-layout-list facets-layout-list--text facets__list list-unstyled';
      list.setAttribute('role', 'listbox');

      options.forEach(function (option) {
        var li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sl-sort-option';
        btn.setAttribute('role', 'option');
        var isActive = option.value === select.value;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) btn.classList.add('sl-sort-option--active');
        btn.textContent = option.textContent.trim();
        btn.addEventListener('click', function (event) {
          if (isMobile) event.stopImmediatePropagation();
          if (select.value !== option.value) {
            select.value = option.value;
            // facets.js does not re-render this block after a sort change, so refresh it here.
            summaryLabel.textContent = option.textContent.trim();
            Array.prototype.forEach.call(list.querySelectorAll('.sl-sort-option'), function (other) {
              var on = other === btn;
              other.classList.toggle('sl-sort-option--active', on);
              other.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          details.removeAttribute('open');
          summary.focus();
        });
        li.appendChild(btn);
        list.appendChild(li);
      });

      panel.appendChild(list);
      details.appendChild(panel);
      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open && isMobile) {
          details.scrollIntoView({
            block: 'nearest',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      });

      wrap.classList.add('sl-sort-select-hidden');
      wrap.parentNode.insertBefore(details, wrap.nextSibling);
      select.dataset.slSortEnhanced = 'true';
    }

    function enhanceAllSortSelects(root) {
      (root || document)
        .querySelectorAll('.sl-active select.facet-filters__sort, .sl-active .mobile-facets__sort select')
        .forEach(enhanceSortSelect);
    }

    function watchSortingContainers() {
      document.querySelectorAll('.sl-active .facet-filters.sorting').forEach(function (sortingEl) {
        if (sortingEl.dataset.slSortWatched === 'true') return;
        sortingEl.dataset.slSortWatched = 'true';
        var observer = new MutationObserver(function () {
          enhanceAllSortSelects(sortingEl);
        });
        observer.observe(sortingEl, { childList: true, subtree: true });
      });
    }

    function watchMobileSortContainers() {
      document.querySelectorAll('.sl-active .mobile-facets__main').forEach(function (containerEl) {
        if (containerEl.dataset.slMobileSortWatched === 'true') return;
        containerEl.dataset.slMobileSortWatched = 'true';
        var observer = new MutationObserver(function () {
          enhanceAllSortSelects(containerEl);
        });
        observer.observe(containerEl, { childList: true, subtree: true });
      });
    }

    document.addEventListener('click', function (event) {
      document
        .querySelectorAll('.sl-active .facets__disclosure[open], .sl-active .sl-mobile-sort-disclosure[open]')
        .forEach(function (details) {
          if (!details.contains(event.target)) {
            details.removeAttribute('open');
          }
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
      enhanceAllSortSelects(document);
      watchSortingContainers();
      watchMobileSortContainers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-bestsellers-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-product');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 220) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-collection-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    if (!wrap.closest('.sl-collrail')) return;
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-coll');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 220) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-featured-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    if (!wrap.closest('.sl-blog')) return;
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-post');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 300) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-product');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 220) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-gift-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(root, sel) { return root.querySelector(sel); }
    function qsa(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function initFinder(root) {
      if (!root || root.__slGiftFinder) return;
      root.__slGiftFinder = true;

      var steps = qsa(root, '[data-gf-step]');
      var stepsEl = qs(root, '[data-gf-steps]');
      var dotsEl = qs(root, '[data-gf-dots]');
      var saidEl = qs(root, '[data-gf-said]');
      var resultEl = qs(root, '[data-gf-result]');
      var itemsEl = qs(root, '[data-gf-items]');
      var noteEl = qs(root, '[data-gf-note]');
      var ctaEl = qs(root, '[data-gf-cta]');
      var statusEl = qs(root, '[data-gf-status]');
      if (!steps.length || !dotsEl || !saidEl || !resultEl || !itemsEl || !noteEl || !ctaEl) return;

      var want = parseInt(root.getAttribute('data-want'), 10) || 4;
      var ratio = root.getAttribute('data-ratio') === 'square' ? 'square' : 'portrait';
      var searchUrl = root.getAttribute('data-search') || '/search';
      var suggestUrl = (root.getAttribute('data-suggest') || '/search/suggest') + '.json';
      var partialText = root.getAttribute('data-partial') || '';
      var emptyText = root.getAttribute('data-empty') || '';
      var emptyHeading = root.getAttribute('data-empty-heading') || '';
      var loadingText = root.getAttribute('data-loading') || '';
      var resultHead = resultEl.querySelector('[data-gf-heading]');
      var resultHeadText = resultHead ? resultHead.textContent : '';
      var money = null;
      try {
        money = new Intl.NumberFormat(root.getAttribute('data-locale') || undefined, { style: 'currency', currency: root.getAttribute('data-currency') || 'GBP' });
      } catch (e) {
        money = null;
      }
      itemsEl.className = 'sl-gf__items' + (want === 6 ? ' sl-gf__items--cols3' : '');

      var shortcuts = [];
      try {
        var sc = qs(root, '[data-gf-shortcuts]');
        var raw = sc ? JSON.parse(sc.textContent) : '';
        String(raw || '').split(/\r?\n/).forEach(function (line) {
          var direct = line.indexOf('=>') > -1;
          var arrow = direct ? '=>' : '->';
          var parts = line.split(arrow);
          if (parts.length < 2) return;
          var url = parts.slice(1).join(arrow).trim();
          var terms = parts[0].split('+').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
          if (terms.length && url) shortcuts.push({ terms: terms, url: url, direct: direct });
        });
      } catch (e) {
        shortcuts = [];
      }

      var answers = [];
      var token = 0;
      var cache = {};

      // An answer can follow the shopper's earlier choices: "| not for Mum, Dad" hides it after any of those choices, "| only for Wife, Husband"
      // shows it only after one of them. Names are the earlier buttons' own names (any capitals); a list can be split with commas, "and" or "or".
      var knownLabels = {};
      qsa(root, '[data-gf-answer]').forEach(function (b) { knownLabels[(b.getAttribute('data-label') || '').toLowerCase()] = true; });

      function ruleNames(text) {
        var out = [];
        String(text || '').toLowerCase().split(',').forEach(function (chunk) {
          chunk = chunk.replace(/[.;]+\s*$/, '').trim();
          if (!chunk) return;
          if (knownLabels[chunk]) { out.push(chunk); return; }
          chunk.split(/\s+(?:and|or)\s+/).forEach(function (piece) {
            piece = piece.trim();
            if (!piece) return;
            if (knownLabels[piece]) { out.push(piece); return; }
            piece.split(/\s*[&\/]\s*/).forEach(function (p) { p = p.trim(); if (p) out.push(p); });
          });
        });
        return out;
      }

      // whether an answer button is offered after the choices made so far (a "only for" list with no known name in it is ignored, so a typo
      // can not make an answer vanish)
      function shownBy(chip, labels) {
        var hit = function (list) { return list.some(function (n) { return labels.indexOf(n) > -1; }); };
        var hide = chip.getAttribute('data-hide');
        if (hide && hit(ruleNames(hide))) return false;
        var only = chip.getAttribute('data-only');
        if (only) {
          var names = ruleNames(only).filter(function (n) { return knownLabels[n]; });
          if (names.length && !hit(names)) return false;
        }
        return true;
      }

      // a question is never left without answers: if the rules would hide every button, they are all shown
      function applyRules(ignore) {
        var labels = answers.map(function (a) { return a.label.toLowerCase(); });
        steps.forEach(function (s) {
          var chips = qsa(s, '[data-gf-answer]');
          var shown = chips.map(function (c) { return ignore || shownBy(c, labels); });
          if (shown.indexOf(true) < 0) shown = shown.map(function () { return true; });
          chips.forEach(function (c, i) { c.hidden = !shown[i]; });
        });
      }

      function say(msg) {
        if (statusEl) statusEl.textContent = msg || '';
      }

      function searchLink(words) {
        return searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(words.join(' ')) + '&type=product';
      }

      // every line whose answers are all among the shopper's answers, in the order they were written
      function shortcutsFor(list) {
        var labels = list.map(function (a) { return a.label.toLowerCase(); });
        return shortcuts.filter(function (s) {
          return s.terms.every(function (t) { return labels.indexOf(t) > -1; });
        });
      }

      function verify(url) {
        if (url.charAt(0) !== '/') return Promise.resolve(true);
        return fetch(url, { method: 'HEAD' }).then(function (r) { return r.ok; }).catch(function () { return false; });
      }

      // a collection's own first products, as the same shape the search gives (sold-out ones left out)
      function fromPage(url) {
        var m = /^(.*?\/collections\/[^\/?#]+)/.exec(url);
        if (!m) return Promise.resolve([]);
        var prefix = m[1].split('/collections/')[0];
        return fetch(m[1] + '/products.json?limit=' + Math.min(250, want * 4), { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('page ' + r.status);
            return r.json();
          })
          .then(function (d) {
            var out = [];
            ((d && d.products) || []).forEach(function (p) {
              var best = null;
              var avail = false;
              (p.variants || []).forEach(function (v) {
                var n = parseFloat(v.price);
                if (!isNaN(n) && (best === null || n < best)) best = n;
                if (v.available) avail = true;
              });
              if (!avail) return;
              out.push({
                handle: p.handle,
                title: p.title,
                url: prefix + '/products/' + p.handle,
                image: (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '',
                price_min: best === null ? null : String(best)
              });
            });
            return out;
          })
          .catch(function () { return []; });
      }

      function suggest(q) {
        if (cache[q]) return cache[q];
        var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
        var p = fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('search ' + r.status);
            return r.json();
          })
          .then(function (d) {
            var list = d && d.resources && d.resources.results && d.resources.results.products;
            return Array.isArray(list) ? list : [];
          });
        cache[q] = p;
        p.catch(function () { delete cache[q]; });
        return p;
      }

      // every set of `size` answers, earliest answers first
      function combos(n, size) {
        var out = [];
        (function pick(start, acc) {
          if (acc.length === size) {
            out.push(acc.slice());
            return;
          }
          for (var i = start; i < n; i++) {
            acc.push(i);
            pick(i + 1, acc);
            acc.pop();
          }
        })(0, []);
        return out;
      }

      function find(words) {
        var n = words.length;
        var seen = {};
        var items = [];
        var fullCount = 0;
        var size = n;
        function add(p) {
          var k = p.handle || p.url;
          if (seen[k]) return;
          seen[k] = 1;
          items.push(p);
        }
        function tier() {
          var sets = combos(n, size);
          return Promise.all(sets.map(function (idx) {
            return suggest(idx.map(function (i) { return words[i]; }).join(' ')).catch(function () { return []; });
          })).then(function (lists) {
            if (size === n) {
              fullCount = lists[0].length;
              lists[0].forEach(add);
              return;
            }
            // products that turn up in more of this tier's searches come first; after that, products near the top of
            // their search come before products further down it, so every answer gets a say instead of the first
            // answer filling the whole list
            var info = {};
            var order = [];
            lists.forEach(function (list, li) {
              list.forEach(function (p, pos) {
                var k = p.handle || p.url;
                if (!info[k]) {
                  info[k] = { p: p, s: 0, pos: pos, li: li };
                  order.push(k);
                }
                info[k].s += 1;
              });
            });
            order
              .map(function (k) { return info[k]; })
              .sort(function (a, b) { return (b.s - a.s) || (a.pos - b.pos) || (a.li - b.li); })
              .forEach(function (o) { add(o.p); });
          });
        }
        function next() {
          return tier().then(function () {
            if (items.length >= want || size <= 1) return;
            size -= 1;
            return next();
          });
        }
        return next().then(function () {
          var shown = items.slice(0, want);
          return { items: shown, partial: shown.length > Math.min(fullCount, want) };
        });
      }

      function imgSrc(p) {
        var u = (p.featured_image && p.featured_image.url) || p.image || '';
        if (!u) return '';
        if (u.indexOf('//') === 0) u = 'https:' + u;
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      }

      function priceText(p) {
        var v = parseFloat(p.price_min != null ? p.price_min : p.price);
        if (isNaN(v)) return '';
        return money ? money.format(v) : v.toFixed(2);
      }

      function card(p) {
        var a = el('a', 'sl-gf__item');
        a.href = p.url;
        var thumb = el('span', 'sl-gf__thumb sl-gf__thumb--' + ratio);
        var src = imgSrc(p);
        if (src) {
          var im = document.createElement('img');
          im.src = src;
          im.alt = '';
          im.loading = 'lazy';
          thumb.appendChild(im);
        }
        var body = el('span', 'sl-gf__item-body');
        body.appendChild(el('span', 'sl-gf__item-name', p.title || ''));
        body.appendChild(el('span', 'sl-gf__item-price', priceText(p)));
        a.appendChild(thumb);
        a.appendChild(body);
        return a;
      }

      function skeleton() {
        itemsEl.innerHTML = '';
        itemsEl.setAttribute('aria-busy', 'true');
        for (var i = 0; i < want; i++) {
          var s = el('span', 'sl-gf__item is-skeleton');
          s.appendChild(el('span', 'sl-gf__thumb sl-gf__thumb--' + ratio));
          var b = el('span', 'sl-gf__item-body');
          b.appendChild(el('span', 'sl-gf__bar'));
          b.appendChild(el('span', 'sl-gf__bar sl-gf__bar--short'));
          s.appendChild(b);
          itemsEl.appendChild(s);
        }
      }

      function draw(res) {
        itemsEl.innerHTML = '';
        itemsEl.setAttribute('aria-busy', 'false');
        if (!res.items.length) {
          if (resultHead && emptyHeading) resultHead.textContent = emptyHeading;
          noteEl.textContent = emptyText;
          noteEl.hidden = !emptyText;
          say(emptyText);
          return;
        }
        res.items.forEach(function (p) { itemsEl.appendChild(card(p)); });
        noteEl.textContent = partialText;
        noteEl.hidden = !(res.partial && partialText);
        say(res.items.length + (res.items.length === 1 ? ' match found' : ' matches found'));
      }

      function setView(focusIt, ignoreRules) {
        var n = answers.length;
        var total = steps.length;
        applyRules(ignoreRules);
        steps.forEach(function (s, i) { s.classList.toggle('is-off', !(n < total && i === n)); });
        if (stepsEl) stepsEl.hidden = n >= total;
        resultEl.hidden = n < total;
        qsa(dotsEl, 'i').forEach(function (d, i) { d.classList.toggle('on', i <= n); });
        saidEl.innerHTML = '';
        answers.forEach(function (a, i) {
          var b = el('button', 'sl-gf__said-chip', a.label);
          b.type = 'button';
          b.setAttribute('data-gf-back', String(i));
          b.setAttribute('aria-label', 'Change answer: ' + a.label);
          saidEl.appendChild(b);
        });
        if (focusIt) {
          var h = (n < total ? steps[n] : resultEl).querySelector('[data-gf-heading]');
          if (h) h.focus({ preventScroll: true });
        }
      }

      // walks the matching lines in order and stops at the first one whose page is really there: a => line needs a page with something in
      // stock (its products become the results), a -> line only needs the page to exist. A page that was deleted, hidden or emptied is
      // skipped, so the shopper lands on the next best page instead of on loose search results.
      function livePage(cands) {
        var i = 0;
        function next() {
          if (i >= cands.length) return Promise.resolve(null);
          var c = cands[i++];
          if (c.direct) {
            return fromPage(c.url).then(function (items) {
              return items.length ? { line: c, items: items.slice(0, want) } : next();
            });
          }
          return verify(c.url).then(function (ok) { return ok ? { line: c, items: null } : next(); });
        }
        return next();
      }

      function showResults() {
        var mine = ++token;
        var words = answers.map(function (a) { return a.words; });
        ctaEl.href = searchLink(words);
        noteEl.hidden = true;
        if (resultHead) resultHead.textContent = resultHeadText;
        if (!window.fetch || !window.Promise) {
          window.location.href = ctaEl.href;
          return;
        }
        skeleton();
        say(loadingText);
        livePage(shortcutsFor(answers).slice(0, 8))
          .then(function (hit) {
            if (hit && mine === token) ctaEl.href = hit.line.url;
            return hit && hit.items ? { items: hit.items, partial: false } : find(words);
          })
          .then(function (res) { if (mine === token) draw(res); })
          .catch(function () { if (mine === token) draw({ items: [], partial: false }); });
      }

      function previewStep(n) {
        answers = [];
        for (var i = 0; i < n && i < steps.length; i++) {
          var first = steps[i].querySelector('[data-gf-answer]');
          if (first) answers.push({ label: first.getAttribute('data-label') || '', words: first.getAttribute('data-words') || '' });
        }
        token += 1;
        setView(false, true);
      }

      root.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var pick = t.closest('[data-gf-answer]');
        if (pick && root.contains(pick)) {
          answers.push({ label: pick.getAttribute('data-label') || '', words: pick.getAttribute('data-words') || '' });
          setView(true);
          if (answers.length === steps.length) showResults();
          return;
        }
        var back = t.closest('[data-gf-back]');
        if (back && root.contains(back)) {
          answers = answers.slice(0, parseInt(back.getAttribute('data-gf-back'), 10) || 0);
          token += 1;
          say('');
          setView(true);
          return;
        }
        if (t.closest('[data-gf-again]')) {
          answers = [];
          token += 1;
          say('');
          setView(true);
        }
      });

      root.addEventListener('shopify:block:select', function (e) {
        var i = steps.indexOf(e.target);
        if (i > -1) previewStep(i);
      });

      setView(false);
    }

    function initAll(scope) {
      try {
        [].slice.call((scope || document).querySelectorAll('[data-sl-gf]')).forEach(initFinder);
      } catch (err) {
        if (window.console) console.error('SL Gift Finder', err);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    if (!wrap.closest('.sl-hero-bs')) return;
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-hero-bs__product');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 190) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-quick-links"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('#sl-quick-links-{{ section.id }} [data-sl-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = rail.querySelector('.sl-quick-link-item');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (item ? item.getBoundingClientRect().width : 160) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-rail-wrap]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-sl-rail]');
    var prevBtn = wrap.querySelector('[data-sl-rail-prev]');
    var nextBtn = wrap.querySelector('[data-sl-rail-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = rail.querySelector('.sl-product');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 220) + gap;
    }

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (max <= 0) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = rail.scrollLeft <= 0;
      nextBtn.hidden = rail.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-shop-the-photo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPhoto(root) {
      if (!root || root.__slShopPhoto) return;
      root.__slShopPhoto = true;

      var stage = root.querySelector('[data-sl-sp-stage]');
      var wraps = [].slice.call(root.querySelectorAll('[data-sl-sp-pin-wrap]'));
      if (!stage || !wraps.length) return;
      var open = null;

      function pinOf(w) { return w.querySelector('[data-sl-sp-pin]'); }
      function popOf(w) { return w.querySelector('.sl-sp__pop'); }

      function close(returnFocus) {
        if (!open) return;
        var w = open;
        open = null;
        var btn = pinOf(w);
        var pop = popOf(w);
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (pop) pop.hidden = true;
        w.classList.remove('is-open');
        if (returnFocus && btn) btn.focus();
      }

      // keep the card inside the photo's width: measure it, then shift it sideways by the overhang
      function place(w) {
        var pop = popOf(w);
        if (!pop) return;
        pop.style.setProperty('--sl-sp-shift', '0px');
        var r = pop.getBoundingClientRect();
        var s = stage.getBoundingClientRect();
        var pad = 8;
        var shift = 0;
        if (r.width >= s.width - pad * 2) shift = (s.left + s.width / 2) - (r.left + r.width / 2);
        else if (r.left < s.left + pad) shift = (s.left + pad) - r.left;
        else if (r.right > s.right - pad) shift = (s.right - pad) - r.right;
        pop.style.setProperty('--sl-sp-shift', Math.round(shift) + 'px');
      }

      function show(w) {
        if (open === w) {
          close();
          return;
        }
        close();
        var btn = pinOf(w);
        var pop = popOf(w);
        if (!btn || !pop) return;
        pop.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        w.classList.add('is-open');
        open = w;
        place(w);
      }

      function hot(n, on) {
        [].slice.call(root.querySelectorAll('[data-sl-sp-pin="' + n + '"], [data-sl-sp-item="' + n + '"]')).forEach(function (x) {
          x.classList.toggle('is-hot', on);
        });
      }
      function clearHot() {
        [].slice.call(root.querySelectorAll('.is-hot')).forEach(function (x) { x.classList.remove('is-hot'); });
      }
      function numberOf(t) {
        var h = t.closest ? t.closest('[data-sl-sp-pin], [data-sl-sp-item]') : null;
        return h ? (h.getAttribute('data-sl-sp-pin') || h.getAttribute('data-sl-sp-item')) : null;
      }

      wraps.forEach(function (w) {
        var btn = pinOf(w);
        if (btn) btn.addEventListener('click', function () { show(w); });
      });
      root.addEventListener('mouseover', function (e) {
        var n = numberOf(e.target);
        if (n) hot(n, true);
      });
      root.addEventListener('focusin', function (e) {
        var n = numberOf(e.target);
        if (n) hot(n, true);
      });
      root.addEventListener('mouseout', clearHot);
      root.addEventListener('focusout', clearHot);
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (open && !(t.closest && (t.closest('.sl-sp__pop') || t.closest('[data-sl-sp-pin]')))) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && open) close(true);
      });
      window.addEventListener('resize', function () { if (open) place(open); });

      root.addEventListener('shopify:block:select', function (e) {
        var i = wraps.indexOf(e.target);
        if (i > -1 && open !== wraps[i]) show(wraps[i]);
      });
      root.addEventListener('shopify:block:deselect', function () { close(); });
    }

    function initAll(scope) {
      try {
        [].slice.call((scope || document).querySelectorAll('[data-sl-sp]')).forEach(initPhoto);
      } catch (err) {
        if (window.console) console.error('SL Shop the Photo', err);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-slideshow]').forEach(function (section) {
    var track = section.querySelector('[data-sl-slideshow-track]');
    var slides = section.querySelectorAll('.sl-slideshow__slide');
    var prevBtn = section.querySelector('[data-sl-slideshow-prev]');
    var nextBtn = section.querySelector('[data-sl-slideshow-next]');
    var dots = section.querySelectorAll('[data-sl-slideshow-dot]');
    if (!track || slides.length < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
    }

    prevBtn && prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn && nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        current = closest;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
      }, 100);
    });

    if (section.dataset.autoplay === 'true' && !reduceMotion) {
      var speed = parseInt(section.dataset.speed, 10) || 5000;
      var timer = setInterval(function () { goTo(current + 1); }, speed);
      section.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-tabbed-shelf"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function railControls(panel) {
      var rail = panel.querySelector('[data-sl-ts-rail]');
      var prev = panel.querySelector('[data-sl-ts-prev]');
      var next = panel.querySelector('[data-sl-ts-next]');
      if (!rail || !prev || !next) return { update: function () {} };
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      function step() {
        var card = rail.querySelector('.sl-product');
        var cs = window.getComputedStyle(rail);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return (card ? card.getBoundingClientRect().width : 220) + gap;
      }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (max <= 0) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = rail.scrollLeft <= 0;
        next.hidden = rail.scrollLeft >= max;
      }
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      rail.addEventListener('scroll', update);
      return { update: update };
    }

    function initShelf(root) {
      if (!root || root.__slTabbedShelf) return;
      root.__slTabbedShelf = true;
      var tablist = root.querySelector('[data-sl-ts-tablist]');
      var tabs = [].slice.call(root.querySelectorAll('[data-sl-ts-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-sl-ts-panel]'));
      var links = [].slice.call(root.querySelectorAll('[data-sl-ts-see]'));
      if (!tablist || !tabs.length || tabs.length !== panels.length) return;
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var rails = panels.map(railControls);
      var current = 0;

      function show(i, focus) {
        if (i < 0 || i >= tabs.length) return;
        current = i;
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        links.forEach(function (a) { a.hidden = parseInt(a.getAttribute('data-sl-ts-see'), 10) !== i; });
        rails[i].update();
        if (focus) tabs[i].focus();
        if (tablist.scrollWidth > tablist.clientWidth) {
          var tr = tabs[i].getBoundingClientRect();
          var lr = tablist.getBoundingClientRect();
          var target = tablist.scrollLeft + (tr.left - lr.left) - (lr.width - tr.width) / 2;
          tablist.scrollTo({ left: Math.max(0, target), behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var to = -1;
          if (e.key === 'ArrowRight') to = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') to = (i + tabs.length - 1) % tabs.length;
          else if (e.key === 'Home') to = 0;
          else if (e.key === 'End') to = tabs.length - 1;
          if (to > -1) {
            e.preventDefault();
            show(to, true);
          }
        });
      });

      window.addEventListener('resize', function () { rails[current].update(); });
      root.addEventListener('shopify:block:select', function (e) {
        var i = tabs.indexOf(e.target);
        if (i > -1) show(i);
      });
      rails[current].update();
    }

    function initAll(scope) {
      try {
        [].slice.call((scope || document).querySelectorAll('[data-sl-ts]')).forEach(initShelf);
      } catch (err) {
        if (window.console) console.error('SL Tabbed Shelf', err);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-tone-toggle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-tone-toggle]').forEach(function (toggle) {
    var wrap = toggle.closest('.sl-tone__wrap');
    if (!wrap) return;
    var groups = wrap.querySelectorAll('[data-sl-tone-group]');
    var buttons = toggle.querySelectorAll('.sl-tone-btn');
    if (!groups.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var tone = btn.getAttribute('data-tone');
        groups.forEach(function (group) {
          group.hidden = group.getAttribute('data-sl-tone-group') !== tone;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
